import TrackEventLink from './TrackEventLink';
import styles from './track-event-link-with-icon.module.less';

export const TrackEventLinkWithIcon = ({ children, icon = 'fa-regular fa-arrow-up-right-from-square', ...rest }) => {
    return (
        <TrackEventLink {...rest}>
            {children}
            <i className={[icon, styles.iconRight].join(' ')} />
        </TrackEventLink>
    );
};
